import React from 'react';

import PropTypes from 'prop-types';

import { useCreateReturnContext } from '../../../../context/create-return-provider';
import ReturnItemsTable from './return-items-table';

export const EditableReturnItemsTable = ({ containerWidth }) => {
  const { returnItems } = useCreateReturnContext();

  if (!returnItems) {
    return null;
  }

  return <ReturnItemsTable containerWidth={containerWidth} items={returnItems} />;
};

EditableReturnItemsTable.propTypes = {
  containerWidth: PropTypes.number.isRequired,
};
